<template>
    <div class="item" @click="gotoProject">
        <div class="item-header">
            <div
                class="item-badge"
                :style="statusStyle(value.nominations[0].participantStatus)"
            >
                {{
                    getRegistryItemById(value.nominations[0].participantStatus)
                }}
            </div>
        </div>
        <div class="item-body">
            <div class="item-img">
                <img :src="value.logo" />
            </div>
            <div class="item-title">
                {{ value.name }}
            </div>
            <a v-if="value.completed" class="item-link item-link__completed">
                <InternshipLinkIcon />
                Завершена
            </a>
            <a v-else class="item-link">
                <InternshipLinkIcon />
                Перейти к заявке
            </a>
        </div>
    </div>
</template>

<script>
import InternshipLinkIcon from '@/assets/images/internship/link.svg?inline';
import { makeURL } from '@/tools/http';
import { mapGetters } from 'vuex';

const getters = ['getRegistryItemById'];
export default {
    name: 'InternshipItem',
    methods: {
        makeURL,
        gotoProject() {
            window.open(
                makeURL('project', this.value.alias || this.value.id),
                '_blank'
            );
        },
        statusStyle(participantStatus) {
            switch (this.getRegistryItemById(participantStatus)) {
                case 'Стажер':
                    return { backgroundColor: '#D2F6D9' };
                default:
                    return { backgroundColor: '#D4EAFE' };
            }
        },
    },
    props: {
        value: Object,
    },
    computed: {
        ...mapGetters('data', getters),
    },
    components: {
        InternshipLinkIcon,
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.item-wrapper {
    @include on-desktop {
        width: 33%;
        padding: rem(25) rem(10);
    }
}
.item {
    border-radius: 10px;
    background: #f6f9ff;
    padding: mrem(16) 0;
    margin: mrem(13) 0;
    display: flex;
    flex-direction: column;
    box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.12);
    cursor: pointer;
    @include on-desktop {
        padding: rem(16) 0;
        margin: 0;
        min-width: rem(216);
        max-width: rem(266);
        height: rem(317);
    }
    &:hover {
        box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.2);
    }

    &-badge {
        display: inline-flex;
        align-items: center;
        height: mrem(25);
        padding: mrem(4) mrem(18);
        border-radius: 0 mrem(60) mrem(60) 0;
        background: #d4eafe;

        color: #251f45;
        font-weight: 600;
        line-height: 1;
        font-size: mrem(12);
        @include on-desktop {
            height: rem(25);
            padding: rem(4) rem(18);
            border-radius: 0 rem(60) rem(60) 0;
            font-size: rem(12);
        }
    }

    &-body {
        display: flex;
        flex: 1;
        flex-direction: column;
        padding: 0 rem(18);
        @include on-mobile {
            padding: 0 mrem(32);
        }
    }

    &-img {
        background: #ffffff;
        margin: mrem(16) 0;
        border-radius: mrem(10);
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        padding: mrem(10) mrem(23);

        @include on-desktop {
            margin: rem(16) 0;
            border-radius: rem(10);
            width: rem(180);
            height: rem(100);
            padding: rem(10) rem(23);
        }

        img {
            border-radius: 4px;
            width: 100%;
        }
    }

    &-title {
        color: #251f45;
        font-style: normal;
        font-weight: 700;
        font-size: mrem(16);
        line-height: mrem(24);
        flex: 1;

        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;

        @include on-desktop {
            padding-top: rem(10);
            font-size: rem(16);
            line-height: rem(24);
        }
    }

    &-link {
        margin-top: mrem(16);
        color: #000;
        font-style: normal;
        font-weight: 400;
        line-height: 26px;
        display: flex;
        align-items: center;
        gap: mrem(6);

        @include on-desktop {
            margin-top: rem(16);
            font-size: rem(14);
            line-height: rem(26);
            gap: rem(6);
        }
        svg {
            width: mrem(20);
            height: mrem(20);
            @include on-desktop {
                width: rem(20);
                height: rem(20);
            }
        }
    }
    &-link__completed {
        color: #98a0a9;
        svg {
            path {
                fill: #98a0a9;
            }
        }
    }
}
</style>
